"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollaborationToken = void 0;
const PlatformToken_1 = require("./PlatformToken");
class CollaborationToken extends PlatformToken_1.PlatformToken {
    constructor(token) {
        super(CollaborationToken.TOKEN_TYPE, token);
    }
    get projectId() {
        return this.subject;
    }
}
exports.CollaborationToken = CollaborationToken;
CollaborationToken.TOKEN_TYPE = 'participant';
//# sourceMappingURL=CollaborationToken.js.map